import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid, Typography } from '@mui/material';
import { SYMBOL } from '../../config';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const PartnerViewModal = ({ handleClose, open, viewData }) => {
  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{
          '& .MuiPaper-root': {
            width: '800px !important',
            maxWidth: '100% !important',
            background: '#1d1e1f',
            color: '#fff',
            border: ' 1px solid #ffffff59',
          },
          '& .MuiDialogContent-root': {
            borderBottom: 'none',
            borderTop: ' 1px solid #ffffff59',
            '::-webkit-scrollbar': { width: '6px' },
            '::-webkit-scrollbar-track': { background: '#ffffff66' },
            '::-webkit-scrollbar-thumb': { background: '#3b3b3b' },
          },
          '& .MuiDialog-container': {
            backdropFilter: 'blur(8px)',
          },
        }}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          <div style={{ color: '#fff9e6' }}>View</div>
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Grid
            container
            spacing={2}
            sx={{
              '& p': {
                border: '0.5px dashed #ffffff59',
                borderRadius: '5px',
                p: '5px',
                mb: '8px',
                color: 'rgb(255 255 255 / 74%)',
              },
            }}
          >
            <Grid item md={12} sm={12} xs={12}>
              <>
                <Typography
                  component={'div'}
                  sx={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    pb: '0.1rem',
                    mb: '0.5rem',
                    borderBottom: '1px solid #ffffff59',
                  }}
                >
                  Partner Information:-
                </Typography>
                <>
                  <Typography sx={{ fontSize: '1rem', py: '5px' }}>
                    Company Name: <span>{viewData?.attributes?.companyName || 'NA'}</span>
                  </Typography>
                  <Typography sx={{ fontSize: '1rem', py: '5px' }}>
                    Company Website: <span>{viewData?.attributes?.companyWebsite || 'NA'}</span>
                  </Typography>
                  <Typography sx={{ fontSize: '1rem', py: '5px' }}>
                    phone: <span>{viewData?.attributes?.phone || 'NA'}</span>
                  </Typography>
                  <Typography sx={{ fontSize: '1rem', py: '5px' }}>
                    Facebook Handle: <span>{viewData?.attributes?.facebookHandle || 'NA'}</span>
                  </Typography>
                  <Typography sx={{ fontSize: '1rem', py: '5px' }}>
                    Industry: <span>{viewData?.attributes?.industry || 'NA'}</span>
                  </Typography>
                  <Typography sx={{ fontSize: '1rem', py: '5px' }}>
                    Email: <span>{viewData?.attributes?.email || 'NA'}</span>
                  </Typography>
                  <Typography sx={{ fontSize: '1rem', py: '5px' }}>
                    Description: <span>{viewData?.attributes?.description || 'NA'}</span>
                  </Typography>

                  <Typography sx={{ fontSize: '1rem', py: '5px' }}>
                    CreatedAt: {new Date(viewData?.attributes?.createdAt).toDateString()}
                  </Typography>
                  <Typography sx={{ fontSize: '1rem', py: '5px' }}>
                    UpdatedAt: {new Date(viewData?.attributes?.updatedAt).toDateString()}
                  </Typography>
                </>
              </>
            </Grid>
          </Grid>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
};

export default PartnerViewModal;
